<template>
  <div class="caseDesc">
    <el-dialog
      :title="caseData.name+'  '+(caseData.casetime==null?'':caseData.casetime)"
      :close-on-click-modal="false"
      :fullscreen="true"
      @closed="onClosed"
      :visible.sync="isShow">

      <div class="videoDiv" v-if="caseData.videotype!=null&&caseData.videotype!=''">
        <el-divider content-position="left"><i class="el-icon-video-camera-solid"></i>项目视频</el-divider>
        <video style="object-fit:contain" playsinline v-if="caseData.videotype==3" width="100%" height="90%" loop="loop" controls="controls" autoplay="autoplay" muted="muted" >
          <source :src="caseData.videos" >
        </video>
        <video style="object-fit:contain" v-if="caseData.videotype==1" width="100%" height="90%" loop="loop" controls="controls" autoplay="autoplay" muted="muted" :src="$fileDPath+caseData.videos"></video>
        <iframe v-if="caseData.videotype==2" width="100%" height="100%" :src="caseData.videos" ></iframe>
      </div>

      <div class="imgsDiv">
        <el-divider content-position="left"><i class="el-icon-picture"></i>项目照片</el-divider>
        <el-carousel style="height: 90%">
          <el-carousel-item v-for="(item,index) in caseData.imgs.split(',')" :key="index">
            <el-image
              style="width: 100%; height: 100%"
              :src="$fileDPath+item"
              fit="contain"
              :preview-src-list="[$fileDPath+item]"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="contextDiv">
        <el-divider content-position="left"><i class="el-icon-s-order"></i>项目描述</el-divider>
        <div style="width: 100%;height: auto;box-sizing: border-box" v-html="caseData.casedesc"></div>
      </div>

    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'caseDesc',
  props:{
    id:String,
    isShow:false
  },
  data() {
    return {
      caseData:{}
    }
  },
  created() {
    this.getData();
  },
  methods:{
    getData(){
      let _this = this;
      this.$axios.get('/fantis/cases/ftCmsCases/queryById?id='+_this.id)
        .then(function(res){ // 请求成功 HTTP状态码是200
          if(res.data.code == 200){
            var tempData = res.data.result;

            _this.caseData = tempData;
          }else{
            _this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },
    onClosed(){
      this.$emit("close");
    }
  }
}
</script>

<style scoped>
.videoDiv{
  width: 100%;
  height: 900px;
}

.imgsDiv{
  width: 100%;
  height: 500px;
}

/deep/ .el-carousel__container {
  position: relative;
  height: 100%;
}

.contextDiv{
  width: 100%;
  height: 500px;
}

@media only screen and (max-width: 800px) {
  .videoDiv{
    height: 300px;
  }

  .imgsDiv{
    height: 300px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/views/compCase/caseDesc.vue